luckyBetToggleButton = {};

luckyBetToggleButton.create = function () {
  var button = new PIXI.Container();

  button.luckyBetMessage = undefined;
  button._isPromotion = false;

  button.canPlaceBet = false;

  InputHelpers.addGenerics(button);
  button._flags.showLuckyBetActive = false;

  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.canShow = function () {
    return !gameController.inFreeSpins && this._flags.platformVisible;
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;
    const goldenbetStakes = this.gameConfig.data.slotConfig.gameModes.GOLDENBET_BUY.coinSizes;
    const baseStake =
      resourceManager.getController('stakeController').BaseStake / this.gameConfig.data.slotConfig.defaultNumLines;

    const isCurrentBetAllowed = goldenbetStakes.includes(baseStake);
    button.canPlaceBet = isCurrentBetAllowed;

    var allow =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._isPromotion &&
      this._flags.platformEnabled &&
      goldenbetStakes.length !== 0 &&
      isCurrentBetAllowed;

    this.button.buttonDisabled.alpha = allow ? 1 : 1; // TODO changed this for screen mockup 1: 0.5

    button.luckyBetMessage.visible = this._flags.canSpin && !this._flags.modal.active;

    if (this._flags.modal.active || !this._flags.canSpin) {
      button.luckyBetMessage.alpha = 0;

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }
    }

    return allow;
  };

  button.getCanPlaceBet = function () {
    return button.canPlaceBet;
  };

  button.onConfig = function (config) {
    this._flags.platformEnabled = config.data.uiElements.btnUpstake.enabled;
    this._flags.platformVisible = config.data.uiElements.btnUpstake.visible;

    this.gameConfig = config;
  };

  button.isAllowed = function () {
    return this._flags.platformEnabled;
  };

  button.setupResources = function () {
    let self = this;
    messageBus.subscribe('spinner:GameConfigEvent', function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe('spinner:GameConfigEvent', button.onConfig.bind(button));
    messageBus.subscribe('common:PromotionStarted', button.promotionStarted.bind(button));
    messageBus.subscribe('common:PromotionEnded', button.promotionEnded.bind(button));
  };

  button.onLayoutComplete = function () {
    button.luckyBetMessage = resourceManager.get('backgroundButtons:luckyBetToggleButton:luckyBetMessage');
    button.animParent = resourceManager.get('backgroundButtons:luckyBetToggleButton');

    button.luckyBetMessage.alpha = 0.0;

    button.innerFadeTimer = undefined;
    button.outerFadeTimer = undefined;
  };

  button.showButton = function () {
    if (this.canShow()) {
      if (!button._flags.showLuckyBetActive) {
        this.button.buttonDisabled.visible = true;
        this.button.buttonEnabled.visible = false;
      } else {
        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = true;
      }

      this.button.visible = true;
    } else {
      this.button.visible = false;

      this.button.buttonDisabled.visible = false;
      this.button.buttonEnabled.visible = false;
    }
  };

  button.enterBuyABonus = function () {
    // on entering buy a bonus we must disable lucky bet
    button._flags.showLuckyBetActive = false;
    button.cancelLuckyBet();
  };

  button.cancelLuckyBet = async function () {
    gameController.skipPiggyAnims();
    await gameController.waitForAllPigUpdatesToFinish();

    button.scaleTween?.progress(1);

    if (button.luckyBetMessage !== undefined) {
      button.luckyBetMessage.alpha = 0.0;

      if (button.innerFadeTimer !== undefined) {
        timerManager.stop(button.innerFadeTimer);
      }

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }
    }

    gameData.encoreEnabled = false;
    const stake = button.handleStakeChange(true);

    gameController.currentNonBABStake = stake;
  };

  button.handleStakeChange = function (broadcast) {
    const stakeController = resourceManager.getController('stakeController');
    let bpl = stakeController.BaseStake / this.gameConfig.data.slotConfig.defaultNumLines;
    let luckyBetEnabled = gameData.encoreEnabled;
    const stakeMultiplier = luckyBetEnabled ? 1.5 : 1;
    stakeController.setStakeMultiplier(stakeMultiplier);
    const stake = stakeController.BaseStake * stakeMultiplier;
    game.changeStake(stake, bpl);

    if (broadcast) {
      stakeController.broadcastCurrentStake();
    }

    return stake;
  };

  button.setRecovery = function () {
    // only called when we are recovering the game to set the game as lucky bet active
    button._flags.showLuckyBetActive = true;
    gameData.encoreEnabled = true;
    this.button.buttonDisabled.visible = false;
    this.button.buttonEnabled.visible = true;
    this.toggleOn(true);
    button.handleStakeChange(true);
  };

  button.promotionStarted = function () {
    this._isPromotion = true;
  };

  button.promotionEnded = function () {
    this._isPromotion = false;
  };

  button.toggleOn = async function (fromRecovery = false) {
    gameController.skipPiggyAnims();
    await gameController.waitForAllPigUpdatesToFinish();

    button._flags.showLuckyBetActive = true;

    if (!fromRecovery) {
      const imageToScale = resourceManager.get('backgroundButtons:luckyBetToggleButton:button');
      button.scaleTween?.progress(1);
      button.scaleTween = gsap.fromTo(
        imageToScale.scale, //
        { x: 0.7, y: 0.7 },
        { x: 1, y: 1, duration: 1, ease: 'elastic.out' }
      );

      button.luckyBetMessage.alpha = 1.0;
      button.outerFadeTimer = timerManager.addTimer(2000, undefined, function () {
        button.innerFadeTimer = timerManager.addTimer(
          500,
          function (progress) {
            button.luckyBetMessage.alpha = 1 - progress;
          },
          function () {
            button.luckyBetMessage.alpha = 0.0;
          }
        );
      });
    } else {
      button.button.buttonDisabled.visible = false;
      button.button.buttonEnabled.visible = true;
      Reflex.doSingleRender();
    }

    gameData.encoreEnabled = true;
    button.handleStakeChange(true);
  };

  button.onPressedCallback = function () {
    button._flags.showLuckyBetActive = !button._flags.showLuckyBetActive;

    if (button._flags.showLuckyBetActive) {
      if (button.luckyBetMessage !== undefined) {
        soundManager.play('activateGoldenBet');
        button.toggleOn();
      }
    } else {
      soundManager.play('cancelGoldenBet');
      button.cancelLuckyBet();
      if (button.luckyBetMessage !== undefined) {
      }
    }
  };

  return button;
};

luckyBetToggleButton.initialise = function (json, object) {
  object.setupResources();
};

luckyBetToggleButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'luckyBetToggleButton',
  luckyBetToggleButton.create,
  luckyBetToggleButton.initialise,
  luckyBetToggleButton.getFilesRequired
);
